module.exports = __webpack_public_path__ + "img/Food-and-Beverage-Section-2-bg.f1e9e16d.jpg";